import styled from 'styled-components';
import { zIndexLayers } from 'constants/zIndexLayers';

export const DialogBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000040;
  z-index: ${zIndexLayers.centeredDialogBackdrop};
`;

export const DialogCard = styled.div`
  width: calc(100% - 32px);
  max-width: 760px;
  max-height: calc(100vh - 64px);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${zIndexLayers.centeredDialog};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.White};
  box-shadow: 0px 2px 8px rgba(13, 51, 32, 0.3);
  border-radius: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    max-height: calc(100vh - 32px);
  }
`;

export const DialogHeader = styled.div`
  padding: 28px 32px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey3};

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    padding: 20px 16px 16px;
  }
`;

export const DialogTitle = styled.h2`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 28px;
  line-height: 36px;
  color: ${({ theme }) => theme.colors.TextHighlight1};
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    font-size: 22px;
    line-height: 30px;
  }
`;

export const LastUpdated = styled.p`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  margin: 4px 0 0;
`;

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 24px 32px 32px;

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    gap: 24px;
    padding: 20px 16px;
  }
`;

export const Paragraph = styled.p`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin: 0;
`;

export const Eyebrow = styled.span`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 20px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.TextHighlight1};
  margin: 0;
`;

export const ItemTitle = styled.h4`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextHighlight1};
  margin: 0;
`;

export const PricingTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid ${({ theme }) => theme.colors.Grey3};
  border-radius: 8px;
  overflow: hidden;
`;

export const TableHeaderCell = styled.th`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: left;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  background-color: ${({ theme }) => theme.colors.Grey1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey3};
  padding: 16px 20px;

  &:last-child {
    width: 45%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    padding: 12px;
    white-space: normal;

    &:last-child {
      width: auto;
    }
  }
`;

export const TableCell = styled.td<{ $emphasis?: boolean; $muted?: boolean }>`
  ${({ theme, $emphasis }) => ($emphasis ? theme.fonts.PoppinsSemiBold : theme.fonts.PoppinsText)};
  font-size: 14px;
  line-height: 20px;
  vertical-align: middle;
  color: ${({ theme, $muted }) => ($muted ? theme.colors.TextDisabled : theme.colors.TextDarkGrey)};
  padding: 16px 20px;

  tr + tr > & {
    border-top: 1px solid ${({ theme }) => theme.colors.Grey3};
  }

  &:nth-child(2) {
    white-space: nowrap;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    font-size: 13px;
    padding: 12px;

    &:nth-child(2) {
      white-space: normal;
    }
  }
`;

export const AcknowledgementLabel = styled.label`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
`;

export const Disclaimer = styled.p`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  background-color: ${({ theme }) => theme.colors.Grey1};
  border-radius: 8px;
  padding: 16px 20px;
  margin: 0;
`;

export const DialogFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 32px;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey3};

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }
`;
